import styled, { keyframes } from 'styled-components';
import { spinnerDefaultProps } from './props';
export const CircleStrokeKeyframe = keyframes `
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0px;
  }
  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;
export const CircleSpinnerKeyframe = keyframes `
  0% {
    transform-origin: 50% 50%;
  }
  100% {
    transform: rotate(360deg);
  }
`;
export const CircleSpinningContainer = styled.div `
  ${({ color }) => color != 'currentColor' && `color: var(${color})`};
  width: ${({ size = spinnerDefaultProps.size }) => `var(--spinner-${size}-size)`};
  height: ${({ size = spinnerDefaultProps.size }) => `var(--spinner-${size}-size)`};
  animation: ${CircleSpinnerKeyframe} 1.4s linear infinite;
  z-index: var(--z-index-800-spinner, 800);
`;
export const AnimatedStrokeCircle = styled.circle `
  stroke: currentColor;
  stroke-dasharray: 80px, 200px;
  stroke-dashoffset: 0px;
  animation: ${CircleStrokeKeyframe} 1.4s ease-in-out infinite;
  z-index: var(--z-index-800-spinner, 800);
`;
